const OutletBrandingMixin = {

    mounted(){

        if (this.outlet){
            this.applyBranding()
        }
    },

    data(){
        return {
            style_id: 'style-outlet-branding',
        }
    },

    methods: {

        removeBranding(){

            const stylesheet = document.getElementById(this.style_id)
            if (stylesheet)
                stylesheet.parentNode.removeChild(stylesheet)

            const colour_meta = document.querySelector('meta[name="theme-color"]')
            colour_meta.setAttribute('content', '')
        },

        applyBranding(){

            // Delete existing stylesheet
            this.removeBranding()

            if (this.outlet == null || this.outlet.branding == null)
                return

            // Create new stylesheet
            const stylesheet = document.createElement('style')
            stylesheet.type = 'text/css'
            stylesheet.id = this.style_id
            document.getElementsByTagName('head')[0].appendChild(stylesheet)

            stylesheet.sheet.insertRule(`
                .toolbar.branded,
                .btn-action.branded:not([disabled="true"]),
                .branded .tabbar,
                .header-alert.branded { 
                    background-color: ${this.outlet.branding.background_colour} !important; 
                }
            `)
            stylesheet.sheet.insertRule(`
                .toolbar.branded .center,
                .btn-action.branded:not([disabled="true"]),
                .branded .tabbar .tabbar__label,
                .header-alert.branded { 
                    color: ${this.outlet.branding.text_colour}; 
                }
            `)
            stylesheet.sheet.insertRule(`
                .toolbar.branded .left .back-button--material__icon {
                    fill: ${this.outlet.branding.accent_colour}; 
                }
            `)
            stylesheet.sheet.insertRule(`
                .toolbar.branded .right a,
                .toolbar.branded .toolbar-button--material {
                    color: ${this.outlet.branding.accent_colour}; 
                }
            `)
            stylesheet.sheet.insertRule(`
                .branded .tabbar .tabbar__border {
                    background-color: ${this.outlet.branding.accent_colour}; 
                }
            `)
            stylesheet.sheet.insertRule(`
                .header-alert.branded .header-alert-btnchange {
                    color: ${this.outlet.branding.accent_colour}; 
                }
            `)
            stylesheet.sheet.insertRule(`
                .branded.header-category .header-category-text {
                    color: ${this.outlet.branding.background_colour};
                }
            `)
            stylesheet.sheet.insertRule(`
                .branded.header-category .header-category-container {
                    border-left-color: ${this.outlet.branding.accent_colour};
                }
            `)
            stylesheet.sheet.insertRule(`
                .branded.header-category .header-category-opener {
                    stroke: ${this.outlet.branding.background_colour};
                }
            `)

            // Update meta colour
            const colour_meta = document.querySelector('meta[name="theme-color"]')
            colour_meta.setAttribute('content', this.outlet.branding.background_colour)
        }
    },

    watch: {
        outlet: function(new_outlet, old_outlet){
            this.applyBranding()
        }
    }
}

export default OutletBrandingMixin


// WEBPACK FOOTER //
// ./src/js/mixins/branding.js